import { initAssets } from "./init";
import { thunkSpreader } from "../../../utils/helpers";
import * as thunks from "./thunks";

const thunkEnum = thunkSpreader(thunks);

export const extraReducers = {
  [initAssets.pending]: (state) => {
    state.init.status = "loading";
  },
  [initAssets.fulfilled]: (state, action) => {
    return {
      ...state,
      init: {
        status: "success",
      },
      ...action.payload,
    };
  },
  [initAssets.rejected]: (state) => {
    return {
      ...state,
      init: {
        status: "error",
      },
    };
  },
  ...thunkEnum,
};
